
const selectBrands = document.getElementById('brands');
const selectModels = document.getElementById('models');
const models_data  = document.getElementById('models_data')


selectModels.addEventListener('mousedown', function() {
  if (this.querySelector('option[value="-1"]')) {
      this.querySelector('option[value="-1"]').remove();
  }
});


selectBrands.addEventListener("change", function(){

  selectModels.innerHTML = "";

  const dataIdValue = "P-" + selectBrands.value;
  
  const models_label = models_data.querySelectorAll('label');
  
  var productsURL = "";
  var isSelect = 0;
  var Tukendi = 0;

  var currentURL = window.location.href;

  if (currentURL.indexOf('collections') > 0) {

    var newOption = document.createElement("option");
      
    newOption.text = "Model Seçiniz";
    newOption.value = "-1";
    newOption.selected = true;
    selectModels.appendChild(newOption);
  }
  

  for (var i = 0; i < models_label.length; i++) {

    if (models_label[i].getAttribute("data-id") === (dataIdValue) ) {
      var newOption = document.createElement("option");

      if (models_label[i].getAttribute("data-stock") == "false") {
        newOption.disabled = true;
        stockText = " (Tükendi)";
      } else {
        newOption.disabled = false;
        stockText = "";
      }

      newOption.text = models_label[i].getAttribute("title") + stockText;
      newOption.value = models_label[i].getAttribute("value");
      
      if (isSelect == 0) {
        productsURL = models_label[i].getAttribute("value");

        isSelect = 1;

        if (stockText == "") {
          Tukendi = 1;
        }
      }
      
      selectModels.appendChild(newOption);
    }
  }

  if ((currentURL.indexOf('products') > 0) && (Tukendi == 1)) {
    window.location.href = productsURL;
  }

  
});


selectModels.addEventListener("change", function(){
  
  var currentURL = window.location.href;

  if (currentURL.indexOf('collections') > 0) {

    const url = new URL(window.location.href);
    
    window.location.href = selectModels.value + url.search;
  }

  if ( currentURL.indexOf('products') > 0 ) {

    var selectedModelHandle = selectModels.value.split('/').pop();
       
    var urlParams = new URLSearchParams(window.location.search);
    var paramVariant = urlParams.get('variant');

    var selectedColor = $('.js.product-form__input input[type="radio"][value="' + paramVariant + '"]').data('def');   

    var jsURL = '/products/' + selectedModelHandle + '.js';
    var prdURL = '/products/' + selectedModelHandle;

    if (selectedColor != undefined ) {    
       fetch(jsURL)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function(data) {
          data.variants.forEach(function(variant) {
            var slCl = selectedColor.replace(/\s+/g, '').trim().toLowerCase();
            var tlCl = variant.title.replace(/\s+/g, '').trim().toLowerCase();
            // console.log('slCL ', slCl, ' tlCl ', tlCl);
            if (slCl === tlCl ) {
              prdURL = '/products/' + selectedModelHandle + '?variant=' + variant.id;
              // window.location.href = prdURL;
            }
          });
          return prdURL;
        })
        .then(function(pURL) {          
           window.location.href = pURL;
        });
    } else {      
       prdURL = selectModels.value; 
       window.location.href = prdURL;
    }

  }
  
});


window.addEventListener('DOMContentLoaded', function () {
  var urlParams = new URLSearchParams(window.location.search);
  var selectedVal = urlParams.get('filter.v.option.material');

  if (selectedVal) {
    var selectedCol = document.querySelector('.slider-material-item[data-val="' + selectedVal + '"]');
    if (selectedCol) {
      selectedCol.setAttribute('selected', '');
      selectedCol.classList.add('selected');
    }
  }
});


function goProductDetail(target) {

    const linkURL = $(target).closest('.card__media').find('a').attr('href');

    window.location.href = linkURL;
}



function getSelectedModelUrl(filterName) {
  var selectedOption = selectModels.options[selectModels.selectedIndex];

  return selectedOption.value + '?' + filterName;
}





  